export const RESET_CURRENT_ARTIST = 'RESET_CURRENT_ARTIST';

export function resetArtist() {
  return {
    type: RESET_CURRENT_ARTIST
  };
}
